import React from 'react';

const DialogHeaderControls = ({ children }) => (
  <div className="ws-ui-dialog-header-controls">{children}</div>
);

export default DialogHeaderControls;
